/* eslint-disable camelcase */
import {
  getPanelTop,
  getSectionTop,
  getSectionsHistoryTop,
} from 'weblite-router'
import { LocalInsert, LocalRemove } from '@weblite/persist'
import { isLoggedIn } from '$logic/auth'
import { OverlayWappPanel, WappPanel } from '$logic/wapp-panels'
import { SessionStorageKeys } from '$logic/client-device/types'
import { sessionStorageSetItem } from '$func/session-storage'
import { dateWithOffset } from '$logic/client-device/time-offset.service'

export function handleLocationSearch(searchInput: string) {
  const { time, value } = LocalRemove('locationSearch') || {}
  const search = time + 900000 > dateWithOffset() ? value : searchInput

  if (search) {
    sessionStorageSetItem(SessionStorageKeys.LOCATION_SEARCH, search)
    if (!isLoggedIn())
      LocalInsert('locationSearch', { time: dateWithOffset(), value: search })
  }
}

let recentPageViewPageTitle: string

export function setGAPage() {
  const { gtag } = window
  if (!gtag) return

  let page_title = ''
  const activeSection = getSectionsHistoryTop()
  if (!activeSection) return

  if (activeSection === 'overlay') {
    const overlaySectionTop = getSectionTop('overlay')

    page_title =
      overlaySectionTop === 'overlayWapp'
        ? OverlayWappPanel.getTopWappMeta()?.wappId
        : overlaySectionTop === 'modals'
          ? getPanelTop('modals')?.state?.cid
          : overlaySectionTop?.toLowerCase()
  } else {
    const rootLocation = getPanelTop('root')?.location
    if (!rootLocation) return

    if (rootLocation.startsWith('root/auth')) {
      const [authPage] = rootLocation.split('/').slice(-1)
      page_title = authPage
    } else {
      const panel = getSectionTop(activeSection)
      if (!panel) return

      if (panel === 'profile' || panel === 'roomProfile')
        page_title = getPanelTop(panel)?.location ?? 'unknown'
      else {
        const panelState = getPanelTop(panel)?.state || {}
        page_title =
          panel === 'home'
            ? panelState.tab
            : panel === 'wapp'
              ? WappPanel.getTopWappMeta()?.wappId
              : panel
      }
    }
  }

  if (page_title && recentPageViewPageTitle !== page_title) {
    recentPageViewPageTitle = page_title
    gtag('event', 'page_view', { page_title })
    analite('PAGE_VISIT', { name: page_title })
  }
}

let startupDialogsDisabled = false
export function areStartupDialogsDisabled() {
  return startupDialogsDisabled
}

export function disableStartupDialogs() {
  console.log('disableStartupDialogs')
  startupDialogsDisabled = true
}
